export const navLinks = [
  { id: "live", label: "实时前线" },
  { id: "topics", label: "主题分类" },
  { id: "deep", label: "深度爆料" },
  { id: "buzz", label: "网友热议" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于我们" },
];